<form autocomplete="off" [name]="formName" [id]="formName" [formGroup]="formControl"
    (ngSubmit)="handleFormSubmit($event)">
    <shared-forms-address-autocomplete-input autocomplete="off" [showHint]="false"
        (onSelected)="handleAddressSelectedClick($event)" [compact]="compact" [parentForm]="formControl" type="text"
        name="address" [label]="labelAddress" [placeholder]="placeholderAddress">
    </shared-forms-address-autocomplete-input>
    <ng-container *ngIf="!detachFormSubmitControls">
        <shared-forms-submit [loading]="loading$ | async" [disabled]="formControl.pristine" width="normal"
            [parentForm]="formControl">
            {{labelSubmit}}
        </shared-forms-submit>
    </ng-container>

</form>